import { useEffect, useRef, useState } from 'react';
import { tw } from '@/lib/tailwind';
import { Check, Link } from '@alchemer/ui/icons';
import { toast } from '@alchemer/ui/components/sonner';

interface ShareInfoProps {
  sharedCount: number;
  shareUrl: string;
}

function ShareInfo({ sharedCount, shareUrl }: ShareInfoProps) {
  const [isCopied, setIsCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(
    () => () => {
      clearTimeout(resetTimer.current);
    },
    [],
  );

  const handleCopyLink = async () => {
    clearTimeout(resetTimer.current);
    try {
      await navigator.clipboard.writeText(shareUrl);
      setIsCopied(true);
      resetTimer.current = setTimeout(() => setIsCopied(false), 2000);
    } catch {
      toast.error('Clipboard access blocked. You can copy the link manually.', {
        description: shareUrl,
      });
    }
  };

  return (
    <div className={tw('flex justify-between text-sm text-gray-500')}>
      <div>
        Shared with ({sharedCount}) {sharedCount === 1 ? 'user' : 'users'}
      </div>
      <button
        type="button"
        aria-label={isCopied ? 'Link copied' : 'Copy link'}
        className={tw('flex items-center gap-1 hover:text-gray-700')}
        onClick={handleCopyLink}
      >
        {isCopied ? <Check className="text-success-600 size-4" /> : <Link className="size-4" />}
        Copy link
      </button>
    </div>
  );
}

export { ShareInfo };
